module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }